module.exports = __webpack_public_path__ + "assets/img/64@3x.7bb9d796.png";